import { render, staticRenderFns } from "./R-score-distribution-widget.vue?vue&type=template&id=5b5abbf2"
import script from "./R-score-distribution-widget.vue?vue&type=script&lang=js"
export * from "./R-score-distribution-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports